<template>
  <div>
    <v-row justify="center">
      <v-dialog
        v-model="visible"
        content-class="v-dialog--custom"
        persistent
      >
        <v-card>
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-card-title>
              <span class="headl">DISPOSITIVOS DEL CLIENTE</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <p>
                      Seleccionar la empresa para exportar sus dispositivos.
                    </p>
                    <v-alert
                      class="alert_custom"
                      v-if="msjError"
                      type="warning"
                    >
                      <div class="ctn_alert">
                        <v-btn @click="textInfo.flag = 0" color="#000" icon>
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <p class="ctn_alert_text">
                          {{ textInfo.text }}
                        </p>
                      </div>
                    </v-alert>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-combobox
                      ref="company"
                      v-model="form.company"
                      :items="itemsData"
                      :search-input.sync="search"
                      item-value="_id"
                      item-text="name"
                      label="Empresa"
                      placeholder="Digite el nombre de la empresa"
                      :disabled="isMaster == 0"
                      clearable
                      :rules="nameRules"
                    ></v-combobox>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="ctn_btn_shop">
                <v-btn large text @click="this.closeModal" class="mr-2">Cerrar</v-btn>
                <v-btn
                  v-if="hideBtn == false"
                  :disabled="isDisable"
                  @click="validate"
                  large
                  color="primary"
                  >Validar
                </v-btn>
                <v-menu offset-y v-if="hideBtn == true">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      large
                    >
                      DESCARGAR
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item link>
                      <v-list-item-title>
                        <vue-excel-xlsx
                          :columns="columnsReportExcel"
                          :data="response"
                          :file-name="nameReport"
                          :file-type="'xlsx'"
                          :sheet-name="'reporte'"
                          class="text-left w-100"
                        >
                          Excel
                        </vue-excel-xlsx>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item link>
                      <v-list-item-title>
                        <download-csv
                          v-if="visibleBtn == true"
                          class="btn btn-default"
                          :data="response"
                          :name="`${nameReport}.csv`"
                        >
                          .CSV
                        </download-csv>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ClientReportComp",
  components: {},
  props: ["visible"],
  data() {
    return {
      textInfo: { flag: 0, text: "No exisite ningun valor" },
      response: [],
      form: {
        company: null,
      },
      search: "",
      itemsData: [],
      arrayCompany: null,
      valid: true,
      visibleBtn: false,
      hideBtn: false,
      isDisable: false,
      serviceRule: [(v) => !!v || "El campo es requerido"],
      nameRules: [(v) => !!v || "El campo es requerido"],
      fieldRules: [(v) => !!v || "El campo es requerido"],
      columnas: [],
    };
  },
  async mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        if(this.$refs.form) {
          this.$refs.form.reset();
        }
        this.$emit("close");
        // Or any other way you want to close your modal
      }
    });
    // evento despues de nueva estacion
    this.$root.$on("reload", async () => {
      await this.getJsonData();
    });
    await this.getJsonData();
  },
  updated() {
    if(this.isMaster == 0) {
      this.form.company = this.itemsData[0];
    }
  },
  watch: {
    search: {
      handler() {
        this.getJsonData();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["alertSnackbar", "exportClient"]),
    getLoadBtn(dato) {
      if (dato > 0) {
        this.isDisable = true;
      } else {
        this.isDisable = false;
      }
    },
    async getJsonData() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };

          axios
            .get(
              `company/list?page=1&search=${this.search || ''}`,
              { headers: headerToken }
            )
            .then((res) => {
              this.itemsData = res.data.docs;
              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    closeModal() {
      this.hideBtn = false;
      this.response = [];
      this.show = false;
      this.visibleBtn = false;
      this.isDisable = false;
      this.textInfo = {
        flag: 0,
      };
    },
    async validate() {
      this.isDisable = true;
      this.response = await this.exportClient({
        company: this.form.company,
      });

      if (this.$refs.form.validate() && this.response.length > 0) {
        this.visibleBtn = true;
        this.hideBtn = true;
        this.isDisable = false;
      } else {
        this.visibleBtn = false;
        this.isDisable = true;
        this.textInfo = {
          flag: 1,
          text: "No se encontró ninguna información con los parámetros establecidos",
        };
      }
    },
    async registerForm() {
      try {
        if (this.response.length > 0) {
          this.textInfo = {
            flag: 2,
          };
          this.closeModal();
          this.$root.$emit("reload"); // parametro update tabla
          this.alertSnackbar({
            snackbar: true,
            text: "Se genero un reporte de un dispositivo.",
          });
        } else {
          this.textInfo = {
            flag: 1,
            text: "No se encontró ninguna información con los parámetros establecidos",
          };
        }
      } catch (error) {
        this.alertSnackbar({
          snackbar: 1,
          text: "ocurrio un error con el servidor.",
        });
      }
    },
  },
  computed: {
    ...mapGetters([
      'isMaster'
    ]),

    nameReport() {
      let date = new Date();
      let formattedDate = moment(date).format('YYYYMMDD_h:mm:ss');
      return `Reporte_dispositivos_${formattedDate}`;
    },

    msjError() {
      if (this.textInfo.flag != 0) {
        return this.textInfo;
      } else {
        return null;
      }
    },

    columnsReportExcel() {
      let columns = [
        {
          label: "Idx",
          field: "IDX",
        },
        {
          label: "NUI",
          field: "NUI",
        },
        {
          label: "Nombre",
          field: "Nombre",
        },
        {
          label: "Tipo Dispositivo",
          field: "Tipo",
        },
        {
          label: "Serial",
          field: "Serial",
        },
        {
          label: "Cód. Interno",
          field: "CodInterno",
        },
        {
          label: "Perfil",
          field: "Perfil",
        },
        {
          label: "Estado",
          field: "Estado",
        },
        {
          label: "Zona",
          field: "Zona",
        },
        {
          label: "Ciclo",
          field: "Ciclo",
        },
        {
          label: "Ruta",
          field: "Ruta",
        },
        {
          label: "Estrato",
          field: "Estrato",
        },
        {
          label: "Direccion",
          field: "Direccion",
        },
        {
          label: "Ciudad",
          field: "Ciudad",
        },
        {
          label: "Latitud",
          field: "Latitud",
        },
        {
          label: "Longitud",
          field: "Longitud",
        },
        {
          label: "Último envío medidor",
          field: "Último envío medidor",
        },
        {
          label: "Consumo hoy",
          field: "Consumo hoy",
        },
        {
          label: "Lectura medidor",
          field: "Lectura medidor",
        },
        {
          label: "Unidades",
          field: "Unidades",
        },
        {
          label: "Fecha de creación",
          field: "Fecha de creacion",
        },
      ];
      if(this.isMaster != 0) {
        columns.concat([
          {
          label: "Empresa",
          field: "Empresa",
          },
          {
            label: "NombreDomoticz",
            field: "NombreDomoticz",
          },
          {
            label: "ID Nodo",
            field: "nodeID",
          },
          {
            label: "ID Nodo Hijo",
            field: "childID",
          },
        ]);
      }
      return columns;
    },

    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
};
</script>
<style lang="scss" scope>
@import "../../assets/scss/base.scss";
.ctn_btn_shop {
  display: flex;
  flex-direction: row;
}
</style>
